<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">达人积分统计</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>达人状态：</label>
          <el-select v-model="talentStatus" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in talentStatusArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>收支类型：</label>
          <el-select v-model="subType" placeholder="Select" style="width: 8em" @change="typeChange">
            <el-option v-for="item in subTypeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>账单类型：</label>
          <el-select v-model="type" placeholder="Select" style="width: 8em">
            <el-option v-for="item in typeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <DatePickerRange title="时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="content-input-item">
          <SearchComponents :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)"/>
          <el-checkbox v-model="limitState" style="margin-left: 8px;">有限制</el-checkbox>
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" @click="getPage(true)" :loading="searchLoading"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div style="display: flex; align-items: center;">
          <SearchUidOrPhone style="margin-right: 16px;" @confirm="openDialog($event)" :type="1"/>
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            v-loading="listLoading"
            @cell-click="toggleSelection"
            @selection-change="selsChange"
            @header-click="selsAll"
            border
        >
<!--          <el-table-column type="selection" width="55" align="center" class-name="cursor"/>-->
          <el-table-column property="createTime" label="时间" v-if="checkColList.indexOf('时间') > -1"/>
          <el-table-column property="" label="头像" v-if="checkColList.indexOf('头像') > -1" class-name="cursor">
            <template #default="scope">
              <HeadImg :images="scope.row.headImg" />
            </template>
          </el-table-column>
          <el-table-column label="用户信息" v-if="checkColList.indexOf('用户信息') > -1" width="224">
            <template #default="scope">
              <UserInfoList :row="scope.row" showList="name,phone,uid,birth"/>
              <p>身高：{{ scope.row.height }}cm</p>
              <p>现居城市：{{ scope.row.city }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="账单类型" v-if="checkColList.indexOf('账单类型') > -1"></el-table-column>
          <el-table-column prop="" label="收支" v-if="checkColList.indexOf('收支') > -1">
            <template #default="scope">
              <p>{{scope.row.type > 0 ? '收入' : scope.row.type < 0 ? '支出' : '--'}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="integralNum" label="数量" v-if="checkColList.indexOf('数量') > -1"></el-table-column>
          <el-table-column prop="" label="本周/上周积分" v-if="checkColList.indexOf('本周/上周积分') > -1">
            <template #default="scope">
              <p>{{scope.row.thisWeekNum + '/' + scope.row.lastWeekNum}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="" label="达人状态" v-if="checkColList.indexOf('达人状态') > -1">
            <template #default="scope">
              <p>{{scope.row.talentStatus == 1 ? '待审核' : scope.row.talentStatus == 2 ? '已通过' :  scope.row.talentStatus == 3 ? '不通过' : '--'}}</p>
            </template>
          </el-table-column>
          <el-table-column label="用户日志" v-if="checkColList.indexOf('用户日志') > -1" class-name="cursor" width="200">
            <template #default="scope">
              <UserLog :user-log-list="scope.row.userLogList" />
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import DatePickerRange from '../../components/DatePickerRange'
import SearchComponents from '../../components/SearchComponents'
import BtnGroup from '../../components/BtnGroup'
import ImgViewer from '../../assets/js/imageViewer'
import {
  getIntegralPageList, listIntegralType,
} from '../../api/url'
import { getFormData, postJson, postFormData } from '../../api/api'
import Dialog from "@/assets/js/dialog";
import UserLogDialog from "@/components/UserLog/UserLogDialog";
import UserLog from "@/components/UserLog/UserLog";
import SearchUidOrPhone from '../../components/SearchUidOrPhone'
import IntegralSearchInfoDialog from "@/views/talent/components/IntegralSearchInfoDialog";

export default {
  name: "TalentIntegral",
  components: { DatePickerRange, SearchComponents, BtnGroup, UserLog, SearchUidOrPhone },
  data() {
    return {

      //达人状态
      talentStatusArray: [
        {label: '不限', value: -1},
        {label: '待审核', value: 1},
        {label: '已通过', value: 2},
        {label: '不通过', value: 3}
      ],
      talentStatus: 2,

      // 收支
      subTypeArray: [
        {label: '不限', value: 0},
        {label: '收入', value: 1},
        {label: '支出', value: -1}
      ],
      subType: 0,

      // 收支
      typeArray: [],
      typeListIn: [],
      typeListOut: [],
      type: 0,



      //时间
      startTime: '',
      endTime: '',
      isChecked: true,


      //搜索
      searchType: '',
      searchValue: '',

      //刷新组
      colList: ['时间', '头像', '用户信息', '账单类型', '收支', '数量', '本周/上周积分','达人状态', '用户日志'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,

      listLoading: false,
      searchLoading: false,
      bitchPassLoading: false,
      bitchRejectLoading: false,
      updateReLoading: false,
      updateNewLoading: false,

      idArray: [],

      limitState: false,

    }
  },
  methods: {

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },

    getCheck(val) {
      this.isChecked = val
    },


    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.isChecked = true;
      this.talentStatus = 2;
      this.subType = 0;
      this.type = 0;
      this.searchValue = '';
      this.limitState = false;
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },

    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.userId);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.userId) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['talentStatus'] = this.talentStatus;
      param['type'] = this.type;
      param['subType'] = this.subType;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['searchValue'] = this.searchValue;
      param['searchType'] = this.searchType;
      param['limitState'] = this.limitState?1:0;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getIntegralPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    toggleSelection(row, column, cell, event) {
      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }
      //更新用户日志
      if(column.label == '用户日志') {
        Dialog.open({
          title: '用户日志',
          component: UserLogDialog,
          data: {
            id: row.userId
          },
          close: () => {
            row['userLogList'] = JSON.parse(sessionStorage.getItem('userLog'));
          }
        })
      }

    },

    showImg(idx, list) {
      let imgList = []
      for(let i=0; i< list.length; i++) {
        imgList.push(list[i].img)
      }
      ImgViewer.open({
        imgList,
        imgIndex: idx
      })
    },


    //搜索
    openDialog(e) {
      // console.log(e)
      Dialog.open({
        component: IntegralSearchInfoDialog,
        data: {
          userForm: e,
          width: '500px'
        },
        confirm: () => {
          this.getPage()
        }
      })
    },
    //账单类型
    getTypeList() {
      this.typeArray = [
        {label: '不限', value: 0}
      ]
      getFormData(listIntegralType).then((data) => {
        console.log(data)
        if(data.code == 200){
          let typeList = data.data
          for (let i = 0; i < typeList.length; i++) {
            let obj = {
              label: typeList[i].name,
              value: typeList[i].type
            }
            if (obj.value > 0) {
              this.typeListIn.push(obj)
            } else {
              this.typeListOut.push(obj)
            }
          }
          this.typeArray = this.typeArray.concat(this.typeListIn, this.typeListOut)
        }
      })

    },

    typeChange() {
      this.typeArray = [
        {label: '不限', value: 0}
      ]
      if (this.subType == 0) {
        this.typeArray = this.typeArray.concat(this.typeListIn, this.typeListOut)
      }
      if (this.subType == 1) {
        this.typeArray = this.typeArray.concat(this.typeListIn)
      }
      if (this.subType == -1) {
        this.typeArray = this.typeArray.concat(this.typeListOut)
      }
      this.type = 0
    },




  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getTypeList()
    this.getPage();
  }
}
</script>

<style scoped>

</style>
